import { useEffect } from "react";
import { MapContainer, TileLayer, Circle, CircleMarker, useMap, useMapEvents } from "react-leaflet";

function Clicker({ onPick }) {
  useMapEvents({ click: (e) => onPick({ lat: e.latlng.lat, lon: e.latlng.lng }) });
  return null;
}

function Fly({ pin, radiusKm }) {
  const map = useMap();
  useEffect(() => {
    if (pin) map.flyTo([pin.lat, pin.lon], radiusKm > 30 ? 9 : radiusKm > 12 ? 10 : 11, { duration: 0.8 });
  }, [pin?.lat, pin?.lon]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

export default function MapPicker({ pin, radiusKm, onPick }) {
  return (
    <div className="h-72 overflow-hidden rounded-xl border" data-testid="map-picker">
      <MapContainer center={[pin?.lat || 43.6532, pin?.lon || -79.3832]} zoom={10} style={{ height: "100%", width: "100%" }} scrollWheelZoom>
        <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Clicker onPick={onPick} />
        <Fly pin={pin} radiusKm={radiusKm} />
        {pin && (
          <>
            <Circle center={[pin.lat, pin.lon]} radius={radiusKm * 1000} pathOptions={{ color: "#B65A2B", fillColor: "#B65A2B", fillOpacity: 0.08, weight: 1.5 }} />
            <CircleMarker center={[pin.lat, pin.lon]} radius={6} pathOptions={{ color: "#FBF8F3", fillColor: "#B65A2B", fillOpacity: 1, weight: 2 }} />
          </>
        )}
      </MapContainer>
    </div>
  );
}
